//#region src/olo_handoff_mode.ts
var OloHandoffMode = /* @__PURE__ */ function(OloHandoffMode) {
	OloHandoffMode["Pickup"] = "pickup";
	OloHandoffMode["Curbside"] = "curbside";
	OloHandoffMode["DriveThru"] = "drivethru";
	OloHandoffMode["Delivery"] = "delivery";
	OloHandoffMode["Dispatch"] = "dispatch";
	OloHandoffMode["DineIn"] = "dinein";
	return OloHandoffMode;
}(OloHandoffMode || {});
//#endregion
export { OloHandoffMode };

//# sourceMappingURL=olo_handoff_mode.js.map